<template>
    <div>
        <v-stepper vertical v-model="step" class="px-md-10 px-0">

            <v-stepper-step step="1">
                مرحله ۱
                <small>نوع سفارش</small>
            </v-stepper-step>
            <v-stepper-content class="mx-0 px-1 pr-2" step="1">
                <h5 class="pb-5 text-center"> {{ pageTitle }}</h5>
                <div class="m-3">
                    <v-text-field outlined
                                  dense
                                  v-model="data.organizationName"
                                  hint="لطفا نام مجموعه خود را وارد کنید."
                                  maxLength="50"
                                  counter="50"
                                  :rules="this.$rules.requiredString"
                                  label="نام مجموعه "
                                  append-icon="mdi-domain"/>
                </div>
                <div class="m-3">
                    <v-text-field outlined
                                  dense
                                  v-model="data.brandName"
                                  hint="لطفا نام برند خود را  وارد  کنید."
                                  maxLength="50"
                                  counter="50"
                                  :rules="this.$rules.requiredString"
                                  label="نام برند "
                                  append-icon="mdi-domain"/>
                </div>
                <div class="m-3">
                    <v-text-field outlined
                                  v-model="data.brandSlogan"
                                  dense
                                  hint="لطفا شعار برند خود را وارد نمایید"
                                  placeholder="لطفا شعار برند خود را وارد نمایید"
                                  maxLength="50"
                                  counter="50"
                                  label="شعار برند"
                                  append-icon="mdi-domain"/>
                </div>
                <div class="m-3">
                    <v-switch
                            v-model="data.slogan"
                            dense
                            class="text-right"
                            :label="data.type!=='logo'?'میخواهم شعار در بروشور اضافه شود':'میخواهم شعار در لوگو اضافه شود'"
                    ></v-switch>
                </div>
                <v-btn class="submit-btn" @click="step1Validate">
                    ادامه
                    <span class="fa fa-arrow-left mr-1"></span>
                </v-btn>
            </v-stepper-content>

            <v-stepper-step step="2">
                مرحله ۲
                <small>اطلاعات اولیه سفارش</small>
            </v-stepper-step>
            <v-stepper-content class="mx-0 px-1 pr-2" step="2">
                <div class="mt-2">
                    <div>
                        <v-expansion-panels class="px-1">
                            <v-expansion-panel
                                    class="mb-4 px-1 customStyle"

                            >
                                <v-expansion-panel-header disable-icon-rotate class="px-1">
                                    لطفا زبان طراحی بروشور را انتخاب نمایید.
                                    <div v-if="data.logoLanguage && !isMobile">
                                        <v-chip
                                                close-icon="mdi-close-outline"
                                                color="indigo"
                                                small
                                                class="mx-2"
                                                outlined
                                        >{{ names["langType"] }}
                                        </v-chip>
                                    </div>
                                    <template v-slot:actions>
                                        <v-icon v-if="data.logoLanguage && isMobile" color="teal">mdi-check</v-icon>
                                    </template>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <lang-type @persianName="persianName" class="mb-4"
                                               v-model="data.logoLanguage"></lang-type>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel
                                    class="mb-4 px-1 customStyle"

                            >
                                <v-expansion-panel-header disable-icon-rotate class="px-1">
                                    لطفا نوع سفارش خودرا انتخاب نمایید.

                                    <div class="row mr-2" v-if="!isMobile">
                                        <div v-if="data.orderType">
                                            <v-chip
                                                    v-if="data.orderType"
                                                    close-icon="mdi-close-outline"
                                                    color="indigo"
                                                    small
                                                    class="mx-2"
                                                    outlined
                                            >{{ orderType.find((x) => x.value === data.orderType).text }}
                                            </v-chip>
                                        </div>
                                        <div v-if="data.orderType==='designPrint' && data.printCount">
                                            <v-chip
                                                    v-if="data.printCount"
                                                    close-icon="mdi-close-outline"
                                                    color="indigo"
                                                    small
                                                    class="mx-2"
                                                    outlined
                                            >{{ data.printCount|currency|persianNum }} عدد
                                            </v-chip>
                                        </div>
                                    </div>
                                    <template v-slot:actions>
                                        <v-icon v-if="data.orderType && data.printCount && isMobile" color="teal">
                                            mdi-check
                                        </v-icon>
                                    </template>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-autocomplete
                                            class="m-1"
                                            v-model="data.orderType"
                                            :items="orderType"
                                            dense
                                            item-text="text"
                                            item-value="value"
                                            label="نوع سفارش"
                                            placeholder="لطفا یک گزینه را انتخاب نمایید."
                                            hint="لطفا یک گزینه را انتخاب نمایید."
                                            outlined
                                    ></v-autocomplete>
                                    <v-text-field
                                            v-if="data.orderType==='designPrint'"
                                            class="m-1"
                                            v-model="printCounting"
                                            dense
                                            @keypress="allowOnlyNumbers"
                                            item-text="text"
                                            item-value="value"
                                            label="تعداد چاپ"
                                            placeholder="تعداد وارد شده با مضربی از 1000 محاسبه می شود."
                                            hint="تعداد وارد شده با مضربی از 1000 محاسبه می شود."
                                            outlined
                                    ></v-text-field>
                                    <v-autocomplete
                                            v-if="data.type==='visit_card'"
                                            class="m-1"
                                            :items="printType"
                                            dense
                                            item-text="text"
                                            item-value="value"
                                            label="نوع طرح"
                                            placeholder="لطفا یک گزینه را انتخاب نمایید."
                                            hint="لطفا یک گزینه را انتخاب نمایید."
                                            outlined
                                    ></v-autocomplete>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel
                                    class="mb-4 px-1 customStyle"
                            >
                                <v-expansion-panel-header disable-icon-rotate class="px-1">
                                    لطفا سایز بروشور خود را انتخاب نمایید.
                                    <div class="row mr-2" v-if="!isMobile">
                                        <div v-if="data.size">
                                            <v-chip
                                                    v-if="data.size"
                                                    close-icon="mdi-close-outline"
                                                    color="indigo"
                                                    small
                                                    class="mx-2"
                                                    outlined
                                            >{{ data.size }}
                                            </v-chip>
                                        </div>
                                    </div>
                                    <template v-slot:actions>
                                        <v-icon v-if="data.size && isMobile" color="teal">
                                            mdi-check
                                        </v-icon>
                                    </template>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-row>
                                        <v-autocomplete
                                                class="m-1"
                                                v-model="data.size"
                                                :items="noteSize"
                                                dense
                                                item-text="text"
                                                item-value="value"
                                                label="سایز بروشور"
                                                placeholder="لطفا سایز بروشور خود را مشخص نمایید."
                                                hint="لطفا سایز بروشور خود را مشخص نمایید."
                                                outlined
                                        ></v-autocomplete>
                                    </v-row>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel class="mb-4 px-1 customStyle">
                                <v-expansion-panel-header disable-icon-rotate class="px-1">
                                    لطفا رنگ های بروشور خودرا مشخص نمایید.
                                    <div v-if="data.color.length>0 && colorCount!=='bw' && !isMobile">
                                        <v-chip
                                                v-for="color in data.color"
                                                close-icon="mdi-close-outline"
                                                color="indigo"
                                                small
                                                :color="color"
                                                class="mx-2"
                                                outlined
                                                dense
                                        >{{ color }}
                                        </v-chip>
                                    </div>
                                    <template v-slot:actions>
                                        <v-icon v-if="data.color.length > 0 && isMobile" color="teal">mdi-check</v-icon>
                                    </template>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <color-pickers count="3" v-model="data.color"
                                                   class="mb-4"></color-pickers>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel class="mb-4 px-1 customStyle">
                                <v-expansion-panel-header disable-icon-rotate class="px-1">
                                    لطفا تعداد لت بروشور خود را انتخاب نمایید.
                                    <div v-if="!isMobile">
                                        <v-chip
                                                close-icon="mdi-close-outline"
                                                color="indigo"
                                                small
                                                class="mx-2"
                                                v-if="data.lat && !isMobile"
                                                outlined
                                                dense
                                        >{{ names['latBro'] }}
                                        </v-chip>
                                    </div>
                                    <template v-slot:actions>
                                        <v-icon v-if="data.lat && isMobile" color="teal">mdi-check</v-icon>
                                    </template>

                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <lat-bro @persianName="persianName" v-model="data.lat"
                                             class="mb-4"></lat-bro>
                                    <div>
                                        <div class="m-2" v-for="item in latCount">
                                            <p class="pb-3 mt-8">{{ 'مطالب صفحه ' + item }}</p>
                                            <V8Editor :class="isMobile? '' : 'mx-2' "
                                                      v-model="data.latDesc[item-1]"/>

                                        </div>

                                    </div>


                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel class="mb-4 px-1 customStyle">
                                <v-expansion-panel-header disable-icon-rotate class="px-1">
                                    لطفا نحوه تای بروشور خود را مشخص نمایید.
                                    <div v-if="!isMobile">
                                        <v-chip
                                                close-icon="mdi-close-outline"
                                                color="indigo"
                                                small
                                                class="mx-2"
                                                v-if="data.tie && !isMobile"
                                                outlined
                                                dense
                                        >{{ names['tieBro'] }}
                                        </v-chip>
                                    </div>
                                    <template v-slot:actions>
                                        <v-icon v-if="data.tie && isMobile" color="teal">mdi-check</v-icon>
                                    </template>

                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <tie-bro @persianName="persianName" v-model="data.tie"
                                             class="mb-4"></tie-bro>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel class="mb-4 px-1 customStyle">
                                <v-expansion-panel-header disable-icon-rotate class="px-1">
                                    لطفا سبک طراحی بروشور خود را مشخص نمایید.
                                    <div v-if="!isMobile">
                                        <v-chip
                                                close-icon="mdi-close-outline"
                                                color="indigo"
                                                small
                                                class="mx-2"
                                                v-if="data.designStyle && !isMobile"
                                                outlined
                                                dense
                                        >{{ names['designBro'] }}
                                        </v-chip>
                                    </div>
                                    <template v-slot:actions>
                                        <v-icon v-if="data.designStyle && isMobile" color="teal">mdi-check</v-icon>
                                    </template>

                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <design-bro @persianName="persianName" v-model="data.designStyle"
                                                class="mb-4"></design-bro>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel class="mb-4 px-1 customStyle">
                                <v-expansion-panel-header disable-icon-rotate class="px-1">
                                    لطفا نوع طراحی بروشور خود را مشخص نمایید.
                                    <div v-if="!isMobile">
                                        <v-chip
                                                close-icon="mdi-close-outline"
                                                color="indigo"
                                                small
                                                class="mx-2"
                                                v-if="data.complexity && !isMobile"
                                                outlined
                                                dense
                                        >{{ names['designTypeBro'] }}
                                        </v-chip>
                                    </div>
                                    <template v-slot:actions>
                                        <v-icon v-if="data.complexity && isMobile" color="teal">mdi-check</v-icon>
                                    </template>

                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <design-type-bro @persianName="persianName" v-model="data.complexity"
                                                     class="mb-4"></design-type-bro>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel class="mb-4 px-1 customStyle">
                                <v-expansion-panel-header disable-icon-rotate class="px-1">
                                    لطفا شکل هندسی بروشور خود را مشخص نمایید.
                                    <div v-if="!isMobile">
                                        <v-chip
                                                close-icon="mdi-close-outline"
                                                color="indigo"
                                                small
                                                class="mx-2"
                                                v-if="data.diagram && !isMobile"
                                                outlined
                                                dense
                                        >{{ names['shapeBro'] }}
                                        </v-chip>
                                    </div>
                                    <template v-slot:actions>
                                        <v-icon v-if="data.diagram && isMobile" color="teal">mdi-check</v-icon>
                                    </template>

                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <shape-bro @persianName="persianName" v-model="data.diagram"
                                               class="mb-4"></shape-bro>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </div>
                    <div>
                        <v-expansion-panels>
                            <v-expansion-panel
                                    class="mb-4 px-1 customStyle"

                                    v-if="data.type==='tracet'"
                            >
                                <v-expansion-panel-header disable-icon-rotate class="px-1">
                                    لطفا نوع سفارش و طرح خودرا انتخاب کنید
                                    <div class="row mr-2">
                                        <div v-if="data.orderType">
                                            <v-chip
                                                    v-if="data.orderType"
                                                    close-icon="mdi-close-outline"
                                                    color="indigo"
                                                    small
                                                    class="mx-2"
                                                    outlined
                                            >{{ orderType.find((x) => x.value === data.orderType).text }}
                                            </v-chip>
                                        </div>
                                        <div v-if="data.orderType==='designPrint' && data.printCount">
                                            <v-chip
                                                    v-if="data.printCount"
                                                    close-icon="mdi-close-outline"
                                                    color="indigo"
                                                    small
                                                    class="mx-2"
                                                    outlined
                                            >{{ data.printCount|currency|persianNum }} عدد
                                            </v-chip>
                                        </div>
                                        <div v-if="data.size">
                                            <v-chip
                                                    v-if="data.size"
                                                    close-icon="mdi-close-outline"
                                                    color="indigo"
                                                    small
                                                    class="mx-2"
                                                    outlined
                                            >{{ data.size }}
                                            </v-chip>
                                        </div>
                                        <div v-if="data.designStyle">
                                            <v-chip
                                                    v-if="data.designStyle"
                                                    close-icon="mdi-close-outline"
                                                    color="indigo"
                                                    small
                                                    class="mx-2"
                                                    outlined
                                            >{{ tracetType.find((x) => x.value === data.designStyle).text }}
                                            </v-chip>
                                        </div>
                                    </div>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-autocomplete
                                            v-if="data.type==='tracet' && others"
                                            class="m-1"
                                            v-model="data.size"
                                            :items="sizeTracet"
                                            dense
                                            item-text="text"
                                            item-value="value"
                                            label="سایز تراکت"
                                            placeholder="لطفا سایز تراکت خود را مشخص نمایید."
                                            hint="لطفا یک گزینه را انتخاب نمایید."
                                            outlined
                                    >
                                        <template v-slot:prepend-item>
                                            <v-list-item
                                                    ripple
                                                    @mousedown.prevent
                                                    @click="others = false"
                                            >
                                                <v-list-item-action>
                                                    <p>واردکردن سایز تراکت دلخواه</p>
                                                </v-list-item-action>
                                            </v-list-item>
                                        </template>
                                    </v-autocomplete>
                                    <v-text-field
                                            v-if="!others"
                                            label="سایز تراکت دلخواه"
                                            hint="لطفا سایز درخواستی خود را انتخاب یا وارد نمایید."
                                            placeholder="لطفا سایز درخواستی خود را انتخاب یا وارد نمایید."
                                            dense
                                            v-model="data.size"
                                            outlined
                                            prepend-inner-icon="fa fa-pencil-alt"
                                            clear-icon="mdi-close-circle-outline"
                                            clearable
                                            @click:clear="others=true;data.size=null"
                                    ></v-text-field>
                                    <v-autocomplete
                                            v-if="data.type==='tracet'"
                                            class="m-1"
                                            v-model="data.orderType"
                                            :items="orderType"
                                            dense
                                            item-text="text"
                                            item-value="value"
                                            label="نوع سفارش"
                                            placeholder="لطفا یک گزینه را انتخاب نمایید."
                                            hint="لطفا یک گزینه را انتخاب نمایید."
                                            outlined
                                    ></v-autocomplete>
                                    <v-autocomplete
                                            v-if="data.orderType==='designPrint'"
                                            class="m-1"
                                            v-model="data.designStyle"
                                            :items="tracetType"
                                            dense
                                            item-text="text"
                                            item-value="value"
                                            label="نوع تراکت"
                                            placeholder="لطفا یک گزینه را انتخاب نمایید."
                                            hint="لطفا یک گزینه را انتخاب نمایید."
                                            outlined
                                    ></v-autocomplete>
                                    <v-text-field
                                            v-if="data.type==='tracet' && data.orderType==='designPrint'"
                                            class="m-1"
                                            v-model="printCounting"
                                            dense
                                            item-text="text"
                                            item-value="value"
                                            label="تعداد چاپ"
                                            placeholder="تعداد وارد شده با مضربی از 1000 محاسبه می شود."
                                            hint="تعداد وارد شده با مضربی از 1000 محاسبه می شود."
                                            outlined
                                    ></v-text-field>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel
                                    class="mb-4 px-1 customStyle"

                                    v-if="data.type==='tracet'"
                            >
                                <v-expansion-panel-header disable-icon-rotate class="px-1">
                                    لطفا نوع طرح تراکت را انتخاب نمایید
                                    <div v-if="data.designType">
                                        <v-chip
                                                v-if="data.designType"
                                                close-icon="mdi-close-outline"
                                                color="indigo"
                                                small
                                                class="mx-2"
                                                outlined
                                        >{{ names["trSabk"] }}
                                        </v-chip>
                                    </div>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <tracet-sabk @persianName="persianName" v-model="data.designType"
                                                 class="mb-4"></tracet-sabk>

                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </div>
                </div>
                <div class="row justify-content-between py-2 mx-auto">
                    <v-btn class="submit-btn col-md-1 col-4" @click="step2Validate">
                        ادامه
                        <span class="fa fa-arrow-left mr-1"></span>
                    </v-btn>
                    <v-btn class="mx-4 btn-refund col-md-1 col-4" @click="step = 1">
                        <span class="fa fa-arrow-right mr-1"></span>
                        بازگشت
                    </v-btn>
                </div>
            </v-stepper-content>

            <v-stepper-step step="3">
                مرحله ۳
                <small>مشخصات سایت</small>
            </v-stepper-step>
            <v-stepper-content class="mx-0 px-1 pr-2" step="3">
                <div class="mt-2" v-if="step===3">
                    <div class="">
                        <span class="text-center pb-2">لطفا یک یا چند پوستر مورد علاقه خود را برای ما ارسال کنید. تا تیم طراحی ما، نیاز شما را بهتر درک کنند.</span>
                    </div>
                    <v-file-input
                            v-model="data.file"
                            label=" بارگذاری عکس "
                            outlined
                            accept="image/png, image/jpeg,image/jpg, image/bmp"
                            placeholder="عکس موردنظر خود را بارگذاری کنید."
                            hint="حداکثر حجم هر عکس مورد نظر می‌تواند 1 مگابابت باشد."
                            prepend-inner-icon="mdi-camera"
                            clearable
                            small-chips
                            multiple
                            clear-icon="mdi-close-circle-outline"
                            prepend-icon=""
                            dense
                            class="mt-1 pt-1"
                    >
                    </v-file-input>
                    <div>
                        <span class="text-center pb-2">لطفا لوگو برند خودرابارگذاری کنید</span>
                    </div>
                    <v-file-input
                            v-model="data.brandLogo"
                            label=" بارگذاری عکس "
                            outlined
                            accept="image/png,image/jpeg"
                            placeholder="لطفا لوگو برند خودرابارگذاری کنید."
                            hint="حداکثر حجم هر عکس مورد نظر می‌تواند 1 مگابابت باشد."
                            prepend-inner-icon="mdi-camera"
                            clearable
                            multiple
                            small-chips
                            clear-icon="mdi-close-circle-outline"
                            prepend-icon=""
                            dense
                            class="mt-1 pt-1"
                    >
                    </v-file-input>
                </div>
                <div class="row justify-content-between py-2 mx-auto">
                    <v-btn class="submit-btn col-md-1 col-4" @click="step3Validate">
                        ادامه
                        <span class="fa fa-arrow-left mr-1"></span>
                    </v-btn>
                    <v-btn class="mx-4 btn-refund col-md-1 col-4" @click="step = 2">
                        <span class="fa fa-arrow-right mr-1"></span>
                        بازگشت
                    </v-btn>
                </div>
            </v-stepper-content>

            <v-stepper-step step="4">
                مرحله ۴
                <small>زمان تحویل</small>
            </v-stepper-step>
            <v-stepper-content class="mx-0 px-1 pr-2" step="4">

                <div class="mx-3">
                    <date-picker
                            v-model="data.deliveryTime"
                            color="#00acc1"
                            label="زمان تحویل"
                            input-class="mb-0 rounded"
                            persianDigits
                            clearable
                            :timezone="false"
                            format="YYYY-MM-DD"
                            style="font-size: 13px!important"
                            class="dateSet"
                            display-format="jMMMM jD"
                            :min="countDay"
                    />
                </div>
                <div class="m-3">
                    <v-text-field outlined
                                  dense
                                  v-model="data.businessDescription"
                                  hint="لطفا درمورد حوزه کسب وکارخود توضیح دهید."
                                  maxLength="50"
                                  counter="50"
                                  :rules="this.$rules.requiredString"
                                  label="حوزه کسب وکار "
                                  append-icon="mdi-domain"/>
                </div>

                <div class="row justify-content-between py-2 mx-auto">
                    <v-btn class="submit-btn col-md-1 col-4 mt-5" @click="step4Validate">
                        <span class="fa fa-arrow-left mr-1"></span>
                        ادامه
                    </v-btn>
                    <v-btn class="mx-4 mt-5 btn-refund col-md-1 col-4" @click="step = 3">
                        <span class="fa fa-arrow-right mr-1"></span>
                        بازگشت
                    </v-btn>
                </div>
            </v-stepper-content>


            <v-stepper-step step="5">
                مرحله ۵
                <small>توضیحات</small>
            </v-stepper-step>
            <v-stepper-content class="mx-0 px-1 pr-2" step="5">
                <div class="mt-1">
                    <div class="mb-2">
                        <span class="text-center pb-2">لطفا توضیحات تکمیلی خود در مورد نیازتان را برای متخصصان ما یادداشت نمایید، تا بتوانیم به بهترین شکل ممکن درخواست شما را بررسی و پاسخ دهیم.</span>
                    </div>
                    <V8Editor class="pt-3" v-model="data.description"/>
                </div>

                <div class="row justify-content-between py-2 mx-auto">
                    <v-btn :loading="loading" class="submit-btn col-md-1 col-4 mt-5" @click="submit">
                        <span class="fa fa-save mr-1"></span>
                        ثبت سفارش
                    </v-btn>
                    <v-btn class="mx-4 mt-5 btn-refund col-md-1 col-4" @click="step = 4">
                        <span class="fa fa-arrow-right mr-1"></span>
                        بازگشت
                    </v-btn>
                </div>
            </v-stepper-content>

        </v-stepper>
    </div>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import CKEditorUploadAdapterPlugin from "../../../../core/plugins/CKEditorUploadFileAdapter";
import LogoType from "../../components/logoType";
import LangType from "../../components/langType";
import Properties from "../../components/properties";
import SabkType from "../../components/sabkType";
import ColorPickers from "../../components/colorPickers";
import CardType from "../../components/cardType";
import DesignType from "../../components/designType";
import DesignPaint from "../../components/designPaint";
import ComplicativeType from "../../components/complicativeType";
import ShapeType from "../../components/shapeType";
import LogoShape from "../../components/logoShape";
import {createFormData} from "@/Utilities/FormRequestHelper";
import CardSides from "@/view/pages/components/cardSides";
import TracetSabk from "@/view/pages/site/tracet/tracetSabk";
import BaseStructure from "@/view/pages/site/poster/components/baseStructure";
import BaseLayer from "@/view/pages/site/poster/components/baselayer";
import LatBro from "@/view/pages/site/brochur/components/latBro";
import TieBro from "@/view/pages/site/brochur/components/tieBro";
import DesignBro from "@/view/pages/site/brochur/components/designBro";
import DesignTypeBro from "@/view/pages/site/brochur/components/typeBro";
import ShapeBro from "@/view/pages/site/brochur/components/shapeBro";

export default {
    name: "brochurStepper",
    components: {
        ShapeBro,
        DesignTypeBro,
        DesignBro,
        TieBro,
        LatBro,
        BaseLayer,
        BaseStructure,
        TracetSabk,
        CardSides,
        LogoShape,
        ShapeType,
        ComplicativeType,
        DesignPaint, DesignType, CardType, ColorPickers, SabkType, Properties, LangType, LogoType
    },
    data() {
        return {
            step: 1,
            days: '',
            marker: true,
            others: true,
            orderType: [
                {text: 'فقط طراحی', value: 'design'},
                {text: 'طراحی به همراه چاپ', value: 'designPrint'},
            ],
            editor: {
                editor: ClassicEditor,
                editorConfig: {
                    language: 'fa',
                    contentsLangDirection: 'rtl',
                    extraPlugins: [CKEditorUploadAdapterPlugin],
                }
            },
            mainPrice: "",
            dialogPayment: false,
            designs: false,
            payDialogInfo: {},
            payableTransaction: null,
            colorCount: 'one',
            selectedRows: [],
            count: 0,
            paymentLoading: false,
            noteSize: [
                {text: 'A3', value: 'A3'},
                {text: 'A4', value: 'A4'},
                {text: 'A5', value: 'A5'},
                {text: 'A6', value: 'A6'},
            ],
            data: {
                organizationName: null,
                brandSlogan: null,
                lat: null,
                slogan: 0,
                tie: null,
                diagram: null,
                visitCardType: null,
                posterText: null,
                orderType: null,
                businessDescription: null,
                size: null,
                tarcetType: null,
                designType: null,
                simpleness: null,
                totalConcept: null,
                complexity: null,
                orientation: null,
                printCount: null,
                deliveryTime: null,
                color: [],
                hasBrandSlogan: false,
                preferredCurrency: 'Rial',
                brandName: null,
                logoLanguage: null,
                designStyle: null,
                softness: null,
                latDesc: [],
                user_price: '',
                type: null,
                logoType: null,
                site_type: null,
                file: [],
                brandLogo: [],
                description: '',
            },
            brandSlogan: null,
            orderTypes: [
                {key: 'logo', keyAlias: 'طراحی لوگو', icon: '/media/site/aparat.png'},
                {key: 'visit_card', keyAlias: 'طراحی کارت ویزیت', icon: '/media/site/aparat.png'},
                {key: 'office_set', keyAlias: 'طراحی ست اداری', icon: '/media/site/aparat.png'},
                {key: 'header', keyAlias: 'طراحی سربرگ', icon: '/media/site/aparat.png'},
                {key: 'poster', keyAlias: 'طراحی پوستر', icon: '/media/site/aparat.png'},
                {key: 'office_scan', keyAlias: 'طراحی و چاپ اداری', icon: '/media/site/aparat.png'},
                {key: 'tracet', keyAlias: 'طراحی تراکت', icon: '/media/site/aparat.png'},
            ],
            errors: [],
            dialog: false,
            loading: false,
            rules: [
                v => !!v || 'وارد کردن این فیلد الزامی است'
            ],
            urlRules: [
                (value) => this.isURL(value) || "دامنه سایت باید بصورت https://terminalads.com یا terminalads.com وارد شود. ",
            ],
            errorMsg: '',
            nameErr: '',
            pageTitle: '',
            userWallet: [],
            dialogInfo: null,
            tab: null,
            items: [
                'سفارش ها',
                'ثبت سفارش جدید',
            ],
            userInfo: {},
            statusBadge: '',
            userValid: true,
            isRejected: false,
            isPending: false,
            names: {},
            articleDesc: false,
            enterMine: false,
            userInfoGot: false
        }
    },
    methods: {
        persianName(name, field) {
            this.names[field] = name
        },
        isURL(str) {
            var regex = new RegExp("^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|www\\.){1}([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?");
            var without_regex = new RegExp("^([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?");
            if (regex.test(str) || without_regex.test(str)) {
                return true
            } else {
                return false;
            }
        },
        paymentDialog(data) {
            this.payDialogInfo = data
            this.dialogPayment = true
        },
        step1Validate() {
            if (!this.data.organizationName || !this.data.brandName) {
                this.$toast.error('نام برند و نام مجموعه الزامی است.')
                return
            }else if (this.data.slogan && !this.data.brandSlogan) {
              this.$toast.error('لطفا شعار برند خودرا وارد کنید.')
            } else
            this.step = 2
        },
        step2Validate() {

            const poster = [
                {main: this.data.logoLanguage, name: 'زبان طراحی '},
                {main: this.data.orderType, name: 'نوع سفارش '},
                {main: this.data.lat, name: 'تعداد لت'},
                {main: this.data.color, name: 'رنگ'},
                {main: this.data.designStyle, name: 'سبک طراحی '},
                {main: this.data.diagram, name: 'شکل هندسی '},
                {main: this.data.size, name: 'سایز '},
                {main: this.data.tie, name: 'مدل تای  '},
                {main: this.data.complexity, name: 'نوع طراحی '},
            ];

            for (let val of poster)
                if (val.main === null || val.main.length <= 0) {
                    this.$toast.error(val.name + 'بروشور ' + 'الزامی است.');
                    return;
                }

            if ((this.data.lat === 'twoLats' && this.data.latDesc.length < 4) || (this.data.lat === 'threeLats' && this.data.latDesc.length < 6) || (this.data.lat === 'fourLats' && this.data.latDesc.length < 8) ) {
                this.$toast.error('مطالب صفحات هر لت الزامی است.');
                return false;
            }

            for (let x of this.data.latDesc) {
                if (x === null) {
                    this.$toast.error('مطالب صفحه ' + (this.data.latDesc.indexOf(x) + 1) + ' الزامی است.');
                    return false;
                }
                ;
            }

            if (this.data.orderType === 'designPrint' && !this.data.printCount) {
                this.$toast.error('تعداد چاپ الزامی است.')
                return false;
            }
            this.step = 3;

        },
        step3Validate() {
            if (this.data.brandLogo.length <= 0) {
                this.$toast.error('حداقل یک فایل برای لوگوی برند خود آپلود کنید.');
                return;
            } else this.step = 4
        },
        step4Validate() {
            if (!this.data.deliveryTime) {
                this.$toast.error('زمان تحویل سفارش خود را مشخص کنید.');
            } else if (!this.data.businessDescription) {
                this.$toast.error('توضیحات کسب وکار الزامی است.');
                return;
            } else this.step = 5
        },
        submit() {
            if ((this.$route.name === 'support.index' && !this.data.description) || (this.$route.name === 'support.index' && !this.data.support_time)) {
                this.$toast.error('تمامی فیلدهای نمایش داده شده اجباری می باشند.');
                return;

            } else {
                this.loading = true;
                this.requestApiPost(`form/graphic/brochure`, createFormData(this.data))
                    .then((res) => {
                        if (res.status && res.status === 201) {
                            this.loading = false;
                            this.$emit('eventname', 1)
                            this.$toast.success('با موفقیت ثبت شد.');
                        } else {
                            this.loading = false;
                            this.$toast.warning('لطفا مجددا تلاش کنید')
                        }
                    })
                    .catch((e) => {
                        this.loading = false;
                        if (e.response.status === 500) {
                            this.$toast.error('خطای سمت سرور!')
                        } else
                            this.$nextTick(() => {
                                this.$toast.error(Object.values(e.response.data.errors).map((x) => {
                                    return x.join('\n');
                                }).join(''));
                            })


                        this.errors = e.response.data.errors
                    })
                    .finally(() => {
                        this.loading = false;
                        this.$modal.hideLoading();
                    })
            }
        },
        pay(transactionId) {
            if (this.payDialogInfo.payments.type === 'final') {

                this.requestApiPost(`payment/${this.payDialogInfo.id}/pay`, {transaction_id: this.payDialogInfo.payments.transactions[0].id})
                    .then(response => {
                        this.$toast.success('با موفقیت پرداخت شد!')
                        this.getSites()
                        this.dialogPayment = false
                    }).catch(({res}) => {
                    this.loading = false
                    this.$toast.error(res.data.message)
                })


            } else {
                this.requestApiPost(`payment/${this.payDialogInfo.id}/pay`, {transaction_id: transactionId})
                    .then(response => {
                        this.$toast.success('با موفقیت پرداخت شد!')
                        this.getSites()
                        this.dialogPayment = false
                    }).catch(({res}) => {
                    this.loading = false
                    this.$toast.error(res.data.message)
                })

            }
        },
        getSites(url = this.url, params = this.tableProps) {
            this.$modal.showLoading();
            this.requestApiGet(url, params).then(response => {
                this.userInfo = response.data;
            }).finally(() => {
                this.$modal.hideLoading();
                if (!this.userInfoGot) {
                    this.getUserInfo();
                }
            })
        },
        edit(data) {
            this.$router.push({name: 'admin.user.edit', params: {id: data.id}})
        },
        information(data) {
            this.$router.push({name: 'admin.users.information', params: {id: data.id}})
        },
        checkRoutes() {
            if (this.$route.name === 'tracet.index') {
                this.data.type = 'tracet';
                this.pageTitle = this.orderTypes[6].keyAlias
            }
        },
        changeUnit() {
            this.marker = !this.marker;
            if (this.marker) {
                this.data.preferredCurrency = 'Rial'
            } else this.data.preferredCurrency = 'Toman'
        },
    },
    watch: {
        'data.organozationName': function (value) {
            var regex = /^[a-zA-Z]+$/;
            if (value > 3 && !value.match(regex)) {
                this.nameErr = 'نام مجموعه نمیتواند تنها شامل اعداد باشد.'
            } else
                this.nameErr = '';
        },
        'data.hasBrandSlogan': function (value) {
            if (value) {
                this.data.brandSlogan = this.brandSlogan;
            } else this.data.brandSlogan = null
        },
        colorCount(value) {
            if (value === 'bw') {
                this.data.color = []
            }
        },
        'data.slogan': function (value) {
            if (value) {
                this.data.slogan = 1
            } else this.data.slogan = 0
        }
    },
    computed: {
        main_price: {
            get() {
                return this.$options.filters.currency(this.data.user_price)
            },
            set(value) {
                this.data.user_price = value.replaceAll(',', '')
            }
        },
        countDay: {
            get() {
                const minimum_day = new Date();
                minimum_day.setDate(minimum_day.getDate() + 5);
                return minimum_day;
            },
            set(value) {
            }
        },
        printCounting: {
            set(value) {
                this.data.printCount = value * 1000;
            },
        },
        latCount() {
            switch (this.data.lat) {
                case "twoLats":
                    return 4;
                case "threeLats":
                    return 6;
                case "fourLats":
                    return 8;
                default:
                    return 0;
            }
        },
    },
    mounted() {
        this.checkRoutes();
    }
}
</script>

<style scoped>

</style>